export enum SidePanelType {
  out = 'out',
  in = 'in',
}
